module.exports = __webpack_public_path__ + "img/is.b05a7b5b.svg";